export const attachmentViewtMode = {
  type: "fgAttachmentConfiguration",
  subtype: "Q",
  icon: "fa fa-file",
  name: "Attachment",
  text: "Attachment",
  heading: "Attachment",
  footerText: "From Bluescope Tech",
  label: "Attachment",
  condition: {},
  uuid:crypto.randomUUID(),
  isCmsDocument: false,
  isMultiple: true,
  attachementPurposeList: [],
  disableBrowseAction: true,
  disableDeleteAction: false,
  hideUploadPart: false,
  customClass: "",
  manualApiKey: false,
  descriptionDisabled: false,
  hideDeleteAction: true,
  hideInfoIcon: true,
  key: "DMS_EVENT_ID",
  templateB: false,
  showOnlyPurposeCode: null,
  isLabelContent: "",
  isSupportedFileFormat: "",
  validation: {},
  styles: {},
  formViewMode: null,
  titleRequired: false,
  isValidate: false,
  fileNameValidationEnabled: false,
  titlePattern: "",
  titleMinLength: "",
  titleMaxLength: "",
  fileNamePattern: "",
  fileNameMaxLength: "",
  emptyStateContent: "There are no files attached.",
};
